import styled from 'styled-components';

export const ContainerButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 1em 0;
`;

export const ContainerListManager = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentListManager = styled.div`
  display: grid;
  gap: 4px;
`;
